import React from 'react';

// Mini lobster mascot for header
const MiniLobster = () => (
  <svg viewBox="0 0 120 140" className="w-8 h-9" fill="none">
    <ellipse cx="60" cy="85" rx="35" ry="45" fill="#ff3b3b" />
    <ellipse cx="60" cy="45" rx="25" ry="25" fill="#ff3b3b" />
    <circle cx="50" cy="40" r="6" fill="#0a0a0f" />
    <circle cx="70" cy="40" r="6" fill="#0a0a0f" />
    <circle cx="51" cy="38" r="2" fill="white" />
    <circle cx="71" cy="38" r="2" fill="white" />
    <path d="M45 25 Q35 10 25 15" stroke="#ff3b3b" strokeWidth="4" strokeLinecap="round" fill="none" />
    <path d="M75 25 Q85 10 95 15" stroke="#ff3b3b" strokeWidth="4" strokeLinecap="round" fill="none" />
    <circle cx="25" cy="15" r="4" fill="#ff3b3b" />
    <circle cx="95" cy="15" r="4" fill="#ff3b3b" />
    <ellipse cx="20" cy="80" rx="15" ry="10" fill="#ff3b3b" transform="rotate(-20 20 80)" />
    <ellipse cx="100" cy="80" rx="15" ry="10" fill="#ff3b3b" transform="rotate(20 100 80)" />
    <ellipse cx="60" cy="115" rx="20" ry="8" fill="#e63535" />
    <ellipse cx="60" cy="125" rx="16" ry="6" fill="#cc2f2f" />
    <ellipse cx="60" cy="133" rx="12" ry="5" fill="#b32929" />
  </svg>
);

const FACTORY_CA = process.env.REACT_APP_CFACTORY_ADDRESS || '0x0000000000000000000000000000000000000000';

const shorten = (addr) => {
  if (!addr) return '';
  const a = String(addr);
  return a.length > 12 ? `${a.slice(0, 6)}...${a.slice(-4)}` : a;
};

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0f]/80 backdrop-blur-md border-b border-white/5">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <MiniLobster />
            <span className="text-white font-display font-semibold text-lg">
              ClawdFactory
            </span>
          </div>

          {/* Nav Links */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#live" className="text-white/50 hover:text-white text-sm transition-colors">
              Next Launch
            </a>
            <a href="#launches" className="text-white/50 hover:text-white text-sm transition-colors">
              Launches
            </a>
            <a href="#how" className="text-white/50 hover:text-white text-sm transition-colors">
              How It Works
            </a>
          </nav>

          {/* CFACTORY CA */}
          <div className="flex items-center gap-2">
            <span className="text-white/40 text-xs uppercase tracking-wider hidden sm:block">
              CA
            </span>
            <a
              href={`https://basescan.org/token/${FACTORY_CA}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-white text-xs font-mono transition-colors"
              title={FACTORY_CA}
            >
              {shorten(FACTORY_CA)}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
